/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import { Container } from "@material-ui/core";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { getCompanyClients } from "../../../../services/apiservices/client";
import CircularProgress from "@mui/material/CircularProgress";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import AuthContext from "../../../../hooks/authContext";
import ActionRender from "../../ActionRender";
import { Label } from "../../../../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { AlertCircle, AlertTriangle, Calendar, Download, FileSpreadsheet, FileText, Filter, Info, Mail, Receipt } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import ThemeTable from "../../../../components/Table/ThemeTable";
import { MobileClientIssueTrendsReport } from "../ClientMobileViewReports";
import EmailReports from "../../EmailReports";
import { getIssuesByDateandCompany } from "../../../../services/apiservices/issues";
import { Badge } from "../../../../components/ui/badge";
import { getSettings } from "../../../../services/apiservices/settings";

function ClientIssueTrendsReport(props) {
  const csvHeaders = [
    "Client",
    "Date",
    "Total Issue",
    "High",
    "Medium",
    "Low"
  ];
  const [clientsList, setClientList] = useState([]);
  const [clientsListMaster, setClientsListMaster] = useState([]);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [clients, setClients] = useState();
  const [clientName, setClientName] = useState("All");
  const [settingsData, setSettingsData] = useState();
  const [clientNameList, setClientNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const [loader, setLoader] = useState(false);
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const { setReportData } = auth || {};

  const getColumns = () => {
    const columns = [
      {
        id: "clientName",
        numeric: false,
        disablePadding: false,
        label: "Client",
        isSortable: false,
      },
      {
        id: "date",
        numeric: false,
        disablePadding: false,
        label: "Date",
        isSortable: false,
      },
      {
        id: "issue",
        numeric: false,
        disablePadding: false,
        label: "Total Issue",
        isSortable: false,
      },
      {
        id: "high",
        numeric: false,
        disablePadding: false,
        label: "High",
        isSortable: false,
      },
      {
        id: "medium",
        numeric: false,
        disablePadding: false,
        label: "Medium",
        isSortable: false,
      },
      {
        id: "low",
        numeric: false,
        disablePadding: false,
        label: "Low",
        isSortable: false,
      },
      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
      },
    ];
    if (isMobile || isLandscape) {
      return columns.filter(col => col.id !== "clientName" && col.id !== "appointmentDate" && col.id !== "Action");
    }
    return columns;
  };

  useEffect(() => {
    const getClientsData = async () => {
      const [clientRes, settingsRes] = await Promise.all([
        new Promise((resolve) => getCompanyClients(companyId, resolve)),
        new Promise((resolve) =>
          getSettings("client_settings", companyId, (res) => resolve(res?.data))
        ),
      ]);
      const details = Array.isArray(clientRes?.data) ? clientRes?.data : [];
      const client = details?.map((item) => {
        return {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
      });
      const filteredData = settingsRes?.filter(
        (item) => !item.deleted
      );
      setSettingsData(filteredData?.length ? filteredData : []);
      setClients(details);
      setClientNameList([{ label: "All", value: "All" }, ...client]);
    };
    getClientsData();
  }, []);

  const handleclientNameChange = (e) => {
    const str = e;
    setClientName(str);
    if (str === "All") {
      setClientList(clientsListMaster);
    } else {
      setClientList(() =>
        clientsListMaster?.filter((itme) => {
          let returnFlg = true;
          if (str !== "All" && returnFlg) {
            returnFlg = itme?.clientNameId === str;
          }
          return returnFlg;
        })
      );
    }
  };

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      clientCSV = clientCSV?.map((item) => {
        return [
          item?.clientName,
          item?.date,
          item?.issue,
          item?.high,
          item?.medium,
          item?.low,
        ];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [
          item?.clientName,
          item?.date,
          item?.issue,
          item?.high,
          item?.medium,
          item?.low,
        ];
      });
    }
    return clientCSV;
  }

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
       clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      return [
        rcellItem?.clientName,
        rcellItem?.date,
        rcellItem?.issue,
        rcellItem?.high,
        rcellItem?.medium,
        rcellItem?.low,
      ];
    } else {
      return [
        rcellItem?.clientName,
        rcellItem?.date,
        rcellItem?.issue,
        rcellItem?.high,
        rcellItem?.medium,
        rcellItem?.low,
      ];
    }
  }

  const downloadForExcel = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Client Issue Trends Report');

    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `ClientIssueTrendsReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `ClientIssueTrendsReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const downloadForPDF = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `ClientIssueTrendsReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `ClientIssueTrendsReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const setDownloadCSVData = (event, done, rcellItem) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);

    const reportName = "Client Issue Trends Report";
    const clientName = Array.isArray(rcellItems) ? `${rcellItems[0]?.clientName}` : `${rcellItems?.clientName}`;
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;
    // Create the report details rows
    const reportDetails = [
      [`Client Name: ${clientName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const setDownloadFullCSVData = (event, done) => {
    const clientCSV = clientsList?.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = "All";

    if (clientName !== "All") {
      clientNamefordwonLoad = clientNameList?.filter(
        (item) => item.value === clientName
      )[0]?.label;
    }

    const reportName = "Client Issue Trends Report";
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(
      endDate
    ).format("YYYY-MM-DD")}`;

    const reportDetails = [
      [`Employee Name: ${clientNamefordwonLoad}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV,
    ];

    setClientListCSV(reportDetails);
    done();
  };


  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = clientsList?.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `ClientIssueTrendsReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Client Issue Trends Report');
    let clientNamefordwonLoad = 'All'

    const clientCSV = clientsList?.map((item) => getDatatoFullDownload(item));

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `ClientIssueReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const handleEmailIconClick = async (rcellItem) => {
    const emailSend = true;
    let name;
    if (Array.isArray(rcellItem)) {
      name = rcellItem[0]?.clientName;
    } else {
      name = rcellItem?.clientName;
    }

    const [excelBlob, pdfBlob] = await Promise.all([
      downloadForExcel(rcellItem, emailSend),
      downloadForPDF(rcellItem, emailSend)
    ]);
    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "ClientIssueReport",
        ReportsName: "Client Report",
        Name: name,
        Date: startDate,
        EndDate: endDate,
        pdf: pdfBlob,
        storedData: base64Data,
        fullData: "",
        fullExcelData: ""
      }));
      setOpenEmailDialog(true);
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0]?.label
    }

    const [fullReport, fullExcelReport] = await Promise.all([
      downloadForFullPDF(emailSend),
      downloadForFullExcel(emailSend)
    ]);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
      ...prev,
        FileName: "ClientIssueReport",
        ReportsName: "Client Report",
        Name: clientNamefordwonLoad,
        Date: startDate,
        EndDate: endDate,
        fullData: fullReport,
        fullExcelData: base64Data,
        pdf: "",
        storedData: ""
      }));
      setOpenEmailDialog(true);
    }
  }

  const handleGenerateReport = async() => {
      setLoader(true);
      let paramStartDate = "";
      let paramEndDate = "";

      paramStartDate = startDate;
      paramEndDate = endDate;
      getReportListData(paramStartDate, paramEndDate);
  }

const mapWithClientIds = async (issues) => {
  const grouped = {};

  issues?.forEach((issue) => {
    const createdDate = moment(issue?.createdOn).format("YYYY-MM-DD");
    const key = `${issue?.client?.id}_${createdDate}`;

    if (!grouped[key]) {
      const userClient = clients?.find((c) => c?.id === issue?.client?.id);
      grouped[key] = {
        clientNameId: issue?.client?.id,
        clientName: `${userClient?.firstName ?? ""} ${userClient?.lastName ?? ""}`.trim(),
        date: moment(issue?.createdOn).format("MMMM DD, YYYY"),
        formattedDate: moment(issue?.createdOn).format("MMMM DD, YYYY"),
        issue: 0,
        high: 0,
        medium: 0,
        low: 0,
      };
    }

    grouped[key].issue += 1;
    if (issue?.priority === "High") grouped[key].high += 1;
    if (issue?.priority === "Medium") grouped[key].medium += 1;
    if (issue?.priority === "Low") grouped[key].low += 1;
  });

  const finaleData = Object.values(grouped);

  let sortedData = sortingFunction(finaleData);
  setClientsListMaster(sortedData);

  setClientList(() =>
    sortedData?.filter((itme) => {
      let returnFlg = true;
      if (clientName !== "All") {
        returnFlg = itme.clientId === clientName;
      }
      return returnFlg;
    })
  );

  setLoader(false);
};

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.clientName < b.clientName) return -1;
      if (a.clientName > b.clientName) return 1;

      if (a.date < b.date) return -1;
      if (a.date > b.date) return 1;
      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
    };

    getIssuesByDateandCompany(
      param,
      "All",
      companyId,
      (result) => {
        const data = result;
        
        mapWithClientIds(data);
      },
      (err) => {
        console.log("err>>", err);
      }
    );
  };

const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'High':
        return <AlertCircle className="h-4 w-4 text-destructive" />;
      case 'Medium':
        return <AlertTriangle className="h-4 w-4 text-warning" />;
      case 'Low':
        return <Info className="h-4 w-4 text-muted-foreground" />;
    }
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex,) => {
    switch (hcellItem.id) {
      case "clientName":
        if (
          rowindex !== 0 &&
          clientsList[rowindex - 1].clientName !== rcellItem.clientName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "issue":
        return <Badge variant="secondaryNew" className={"dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600"}>{rcellItem?.issue}</Badge>;
      case "high":
        return (
          <div className="flex items-center justify-center gap-1">
            {getPriorityIcon("High")}
            <span>{rcellItem?.high}</span>
          </div>
        );
      case "medium":
        return (
          <div className="flex items-center justify-center gap-1">
            {getPriorityIcon("Medium")}
            <span>{rcellItem?.medium}</span>
          </div>
        );
      case "low":
        return (
          <div className="flex items-center justify-center gap-1">
            {getPriorityIcon("Low")}
            <span>{rcellItem?.low}</span>
          </div>
        );
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"ClientIssueTrendsReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            clientsList[rowindex - 1].clientName !== rcellItem.clientName
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"ClientIssueTrendsReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"ClientIssueTrendsReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
    }
  };

  const MobileViewData = useMemo(() => {
    if (!clientsList?.length) return [];

    return clientsList?.reduce((acc, item) => {
      const clientName = item?.clientName;

      const record = {
        id: item?.clientNameId,
        date: item?.date,
        clientNameId: item?.clientNameId,
        clientName: item?.clientName,
        issue: item?.issue,
        high: item?.high,
        medium: item?.medium,
        low: item?.low
      };

      const existingGroup = acc?.find((g) => g?.clientName === clientName);

      if (existingGroup) {
        existingGroup?.records?.push(record);
      } else {
        acc?.push({
          clientName,
          records: [record],
        });
      }

      return acc;
    }, []);
  }, [clientsList]);

    const filteredClient = clients?.find((item) => item?.id === clientName);

    const handleEmailDialogClose = async() => {
      setOpenEmailDialog(false);
      await handleGenerateReport();
    }

    const calculateTotals = (clientsList) => {
        let totalIssues = 0;
        let totalHigh = 0;
        let totalMedium = 0;
        let totalLow = 0;

        clientsList?.forEach((item) => {
            totalIssues += item?.issue || 0;
            totalHigh += item?.high || 0;
            totalMedium += item?.medium || 0;
            totalLow += item?.low || 0;
        });

        return { totalIssues, totalHigh, totalMedium, totalLow };
    };

    const { totalIssues, totalHigh, totalMedium, totalLow } = calculateTotals(clientsList);

  return (
    <>
      <Container>
          <PageTitle
            pageTitle="Client Issue Trends Report"
            showBreadcrumb={[
              { label: "Home", to: "/" },
              { label: "Reports" },
              { label: "New Reports" },
              { label: "Client Reports", to: "/reports/newreport/clientreport" },
            ]}
            BreadCrumbCurrentPageTitle={"Client Issue Trends Report"}
            showLastSeen={true}
          ></PageTitle>

          <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
            <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
              <div className="space-y-6">
                <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                  <CardHeader className="pb-12">
                    <div className="flex items-center space-x-2">
                      <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                      <CardTitle className="text-lg sm:text-xl">
                        Report Parameters
                      </CardTitle>
                    </div>
                    <CardDescription className="text-left text-sm sm:text-base">
                      Configure the parameters for your client issue trends report
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="client"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Client Name *
                        </Label>
                        <SingleSelectNew
                          value={clientName}
                          name={"clientName"}
                          label={"Client Name"}
                          onChange={(e) => handleclientNameChange(e)}
                          options={clientNameList}
                          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                          className="w-full min-h-[40px] px-3 py-2"
                        />
                      </div>

                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="startDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Start Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={startDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              // if (newValue) {
                              //   setEndDate(moment());
                              // } else {
                              //   setEndDate(null);
                              // }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="endDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          End Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={endDate}
                            onChange={(newValue) => {
                              setEndDate(newValue);
                              // if (!newValue) {
                              //   setStartDate(null);
                              // }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="flex justify-start sm:justify-end pt-8">
                      <Button
                        type="submit"
                        className="w-full sm:w-auto h-10 text-sm px-6"
                        onClick={() => handleGenerateReport()}
                      >
                        {loader ? (
                          <CircularProgress
                            size={28}
                            style={{ color: "white" }}
                          />
                        ) : (
                          <span className="d-flex flex-center">
                            <FileText className="w-4 h-4 mr-8" /> Generate
                            Report
                          </span>
                        )}
                      </Button>
                    </div>
                  </CardContent>
                </Card>
    
                {loader ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      Fetching report data...
                    </div>
                  </Card>
                ) : clientsList?.length === 0 ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      No Records Found
                    </div>
                  </Card>
                ) : (
                  clientsList?.length > 0 && (
                    <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                      <CardHeader className="pb-16">
                        <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                          <div className="space-y-3 flex-1 min-w-0">
                            <CardTitle className="text-lg sm:text-xl d-flex flex-center">
                              <span>
                                  <Calendar className="h-5 w-5 mr-3 text-blue-600 dark:text-blue-400"/>
                              </span>
                             Client Issue Trends Report Results
                            </CardTitle>
                            <CardDescription className="space-y-2">
                              <div className="font-medium text-sm sm:text-base">
                                {clientName === "All"
                                  ? "All Client Report"
                                  : `Client Report for ${filteredClient?.firstName} ${filteredClient?.lastName}`}
                              </div>
                              <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                              </div>
                            </CardDescription>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handelEmailFullReport()}
                              className="h-8"
                            >
                              <Mail className="mr-4 h-3 w-3" />
                              Email Report
                            </Button>
                            <Popover>
                              <PopoverTrigger asChild>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-8"
                                >
                                  <Download className="mr-4 h-3 w-3" />
                                  Download
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent className="w-40">
                                <div className="space-y-2">
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullPDF()}
                                  >
                                    <FileText className="mr-8 h-3 w-3" />
                                    PDF
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullExcel()}
                                  >
                                    <FileSpreadsheet className="mr-8 h-3 w-3" />
                                    Excel
                                  </Button>
                                  <CSVLink
                                    data={clientsListCSV}
                                    filename={`ClientIssueTrendsReport_${
                                      clientName === "All"
                                        ? "All"
                                        : `${filteredClient?.firstName} ${filteredClient?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                    asyncOnClick={true}
                                    onClick={(event, done) => {
                                      setDownloadFullCSVData(event, done);
                                    }}
                                    className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                  >
                                    <FileSpreadsheet className="mr-16 h-4 w-4" />
                                    <span className="font-medium">CSV</span>
                                  </CSVLink>
                                </div>
                              </PopoverContent>
                            </Popover>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-24 p-24 bg-muted/50 rounded-lg">
                            <div className="text-center">
                            <div className="text-2xl font-bold text-primary">{totalIssues}</div>
                            <div className="text-xs text-muted-foreground">Total Issues</div>
                            </div>
                            <div className="text-center">
                            <div className="text-2xl font-bold text-destructive">{totalHigh}</div>
                            <div className="text-xs text-muted-foreground">High Priority</div>
                            </div>
                            <div className="text-center">
                            <div className="text-2xl font-bold text-warning">{totalMedium}</div>
                            <div className="text-xs text-muted-foreground">Medium Priority</div>
                            </div>
                            <div className="text-center">
                            <div className="text-2xl font-bold text-muted-foreground">{totalLow}</div>
                            <div className="text-xs text-muted-foreground">Low Priority</div>
                            </div>
                        </div>
                      </CardHeader>
                      <CardContent className="p-0 sm:p-6 sm:pt-0">
                        {!isMobile && (
                          <ThemeTable
                            rows={clientsList}
                            headCells={getColumns()}
                            hidePagination={true}
                            renderRowCell={renderRowCell}
                          />
                        )}
                        {isMobile && (
                          <MobileClientIssueTrendsReport
                            MobileViewData={MobileViewData}
                            handleEmailIconClick={handleEmailIconClick}
                            downloadForPDF={downloadForPDF}
                            downloadForExcel={downloadForExcel}
                            clientsListCSV={clientsListCSV}
                            setDownloadCSVData={setDownloadCSVData}
                            startDate={startDate}
                            endDate={endDate}
                            reportName={"ClientIssueTrendsReport"}
                          />
                        )}
                      </CardContent>
                    </Card>
                  )
                )}
              </div>
            </div>
          </div>
          <EmailReports
            open={openEmailDialog}
            onClose={() => handleEmailDialogClose()}
          />
        </Container>
    </>
  );
}

export default ClientIssueTrendsReport;